import { ComponentPropsWithRef } from 'react';
import { Copy } from 'lucide-react';
import { AnimatePresence, motion } from 'motion/react';

import { AnimatedIcon } from '@components/primitives/AnimatedIcon';
import { cn, easeOutSmooth } from '@components/primitives/utilities';

import css from './styles.module.css';

export interface CopyCheckProps extends ComponentPropsWithRef<'span'> {
  state?: 'copy' | 'check';
}

export function CopyCheck({
  state = 'copy',
  className,
  ...props
}: CopyCheckProps) {
  return (
    <span className={cn(css.copyCheck, className)} {...props}>
      <AnimatePresence initial={false}>
        {state === 'check' ? (
          <motion.span
            key="check"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{
              opacity: 0,
              transition: { duration: 0.1, ease: easeOutSmooth },
            }}
            transition={{ duration: 0.2, ease: easeOutSmooth }}
          >
            <AnimatedIcon.Check
              initial="from"
              animate="to"
              transition={{
                duration: 0.2,
                ease: easeOutSmooth,
                delay: 0.1,
              }}
            />
          </motion.span>
        ) : (
          <motion.span
            key="copy"
            initial={{ opacity: 0, scale: 0.7 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.7 }}
            transition={{ duration: 0.2, ease: easeOutSmooth }}
          >
            <Copy aria-hidden />
          </motion.span>
        )}
      </AnimatePresence>
    </span>
  );
}
